import ClientReviewProposal from './review-proposal/client-review-proposal'

export default function FourthStep() {

    return (
        <div className="w-full">
            <ClientReviewProposal />
        </div>
    )
}